import { useEffect, useState } from 'react';
import { useParams, useHistory } from 'react-router';
import { Link } from 'react-router-dom';
import Axios from '../utils/axios';
import Upload from '../statics/images/upload.svg';
import { PatientHeader } from '../components/PatientHeader';

function Prescription() {
	let { visit, id } = useParams();

	const [img, setImg] = useState('');
	const [imgBinary, setImgBinary] = useState('');
	let history = useHistory();
	const [data, setData] = useState('');

	const uploadImage = async (prescription_id) => {
		const body = new FormData();
		body.append('file', imgBinary);

		await Axios.post(`prescription/${prescription_id || visit}/upload_image`, body, {
			headers: { 'Content-Type': 'multipart/form-data' }
		});
	};
	const updateText = async (prescription_id) => {
		const body = { diagnosis: data.diagnosis };
		await Axios.put(`prescription/${prescription_id || visit}`, body);
	};
	const saveData = async () => {
		img && (await uploadImage());
		await updateText();
	};

	const createPrescription = async () => {
		const { diagnosis } = data;
		const body = { patient_id: id, diagnosis };

		const res = await Axios.post(`prescription/create/`, body);
		const prescription_id = res.data && res.data.id.$oid;
		try {
			img && (await uploadImage(prescription_id));
		} catch (error) {
			// eslint-disable-next-line no-console
			console.log(error);
		}
		history.push(`/patient/${id}/prescription/${prescription_id}`);
	};

	const deletePrescription = async () => {
		await Axios.delete(`prescription/${visit}`);
		history.push(`/patient/${id}`);
	};
	useEffect(() => {
		async function fetchPreviousData() {
			const pres_data = await Axios.get(`/prescription/${visit}`);
			setData(pres_data.data);
		}
		async function fetchUserData() {
			const pres_data = await Axios.get(`/patient/${id}`);

			setData(pres_data.data);
		}

		if (visit !== undefined) {
			fetchPreviousData();
		} else {
			fetchUserData();
		}
	}, [visit, id]);

	if (data) {
		const { patient, created, image } = data;
		let firstName, lastName, tel;
		if (patient) {
			({ first_name: firstName, last_name: lastName, tel } = patient);
		} else {
			({ first_name: firstName, last_name: lastName, tel } = data);
		}

		return (
			<div className="shadow-md bg-blue-320">
				<div className="text-centre">
					{
						<PatientHeader
							firstName={firstName}
							lastName={lastName}
							tel={tel}
							id={id}
							created={created}
						/>
					}
					<div id="textInput" className="w-11/12 mx-auto">
						<p htmlFor="file-input" className="pb-2 text-white text-bold">
							توضیحات:
						</p>
						<textarea
							type="textarea"
							name="diagnosis"
							value={data['diagnosis']}
							rows={6}
							cols={3}
							onChange={(e) => {
								e.persist();
								data['diagnosis'] = e.target.value;

								setData({ ...data, diagnosis: e.target.value });
							}}
							id=""
							className="w-full rounded shadow-lg "
						/>
					</div>
					<div className="w-11/12 row-span-6 mx-auto image-upload">
						<p htmlFor="file-input" className="pb-2 text-white m2-4 text-bold">
							تصویر نسخه:
						</p>
						<label htmlFor="file-input">
							<img
								src={img || (image && `${process.env.REACT_APP_STATICS}${image}`) || Upload}
								className={`${
									img || image ? 'w-full' : 'w-1/4'
								} rounded-lg shadow-2xl cursor-pointer mx-auto`}
								alt="نسخه"
							/>
						</label>
						<input
							id="file-input"
							type="file"
							className="hidden"
							accept="image/*"
							disabled={image && visit}
							onChange={(event) => {
								let file = event && event.target.files && event.target.files[0];
								setImgBinary(file);
								setImg(URL.createObjectURL(file));
							}}
						/>
					</div>
					<div className="text-center">
						<button
							className="p-2 px-10 mx-auto my-5 ml-10 text-white rounded shadow bg-cyan-500"
							onClick={() => (visit ? saveData() : createPrescription())}
						>
							{visit ? 'ویرایش' : 'ذخیره'}
						</button>

						<Link
							to={`/patient/${id}/create`}
							className="p-2 px-10 mx-auto my-5 ml-10 text-white bg-green-500 rounded shadow"
							onClick={() => {
								setData({ ...data, diagnosis: '' });
								setImg();
								setImgBinary();
							}}
						>
							نسخه جدید
						</Link>
						{visit && (
							<button
								className="p-2 px-10 mx-auto my-5 ml-10 text-white bg-red-500 rounded shadow"
								onClick={deletePrescription}
							>
								حذف نسخه
							</button>
						)}
						<div className="" />
					</div>
				</div>
			</div>
		);
	} else {
		return (
			<div className="w-screen h-screen bg-green-800">
				<Link
					to="/"
					className="absolute left-0 right-0 w-10 h-10 mx-auto bg-red-900 rounded-lg animate-bounce"
				/>
			</div>
		);
	}
}

export default Prescription;
